import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity as getSchedulingHistory } from './scheduling-history.reducer';
import { getEntity as getScheduling } from '../scheduling/scheduling.reducer';
// import { getEntity } from '../scheduling/scheduling.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Chip, IconButton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { IScheduling } from 'app/shared/model/scheduling.model';
import { Status } from 'app/shared/model/enumerations/scheduling-status.model';
import { OpenInNewRounded } from '@mui/icons-material';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';

export const SchedulingHistoryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const schedulingHistoryEntity = useAppSelector(state => state.schedulingHistory.entity);
  const schedulingEntity = useAppSelector(state => state.scheduling.entity);

  const schedulingId = schedulingHistoryEntity?.scheduling?.id || '';

  useEffect(() => {
    dispatch(getSchedulingHistory(props.match.params.id));
  }, [dispatch, props.match.params.id]);

  useEffect(() => {
    if (schedulingId) {
      dispatch(getScheduling(schedulingId));
    }
  }, [dispatch, schedulingId]);

  const statusChip = ({ status }: IScheduling) => (
    <Chip
      sx={{ width: '115px' }}
      label={status ? <Translate contentKey={`fleetSenseApp.SchedulingStatus.${status}`} /> : ''}
      color={status === Status.SCHEDULED ? 'warning' : status === Status.CANCELED ? 'error' : 'success'}
    />
  );

  const headers = [
    { key: 'created', sortable: true, component: <Translate contentKey="fleetSenseApp.schedulingHistory.created" /> },
    { key: 'status', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.status" /> },
    { key: 'startTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.startTime" /> },
    { key: 'endTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.endTime" /> },
    { key: 'truckImplementPlate', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementPlate" /> },
    { key: 'truckImplementDescription', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementDescription" /> },
    { key: 'userFirstName', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.user" /> },
    { key: 'id', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.id" /> },
    { key: 'description', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.description" /> },
  ];
  const { match } = props;
  return (
    <div>
      <PageHeader
        headingId="scheuling-history-heading"
        headingDataCy="scheulingHistoryHeading"
        contentKey="fleetSenseApp.schedulingHistory.home.title"
        buttonTextKey="fleetSenseApp.scheduling.home.createLabel"
        showButton={false}
        match={match}
      />
      <TableContainer sx={{ mt: 1 }}>
        <Table aria-label="scheduling table">
          <TableHead>
            <TableRow>
              {headers.map((header, i) => (
                <TableCell
                  key={`entity-${i}`}
                  sx={{
                    borderBottom: 'none',
                    paddingBottom: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: 'text.primary',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      alignItems: 'center',
                    }}
                  >
                    {header.component}
                  </Typography>
                </TableCell>
              ))}
              <TableCell sx={{ borderBottom: '0' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                backgroundColor: 'background.paper',

                borderTop: '4px solid',
                borderBottom: '4px solid',
                borderColor: 'primary.main',
              }}
            >
              <CustomHeadTableCell>
                {schedulingHistoryEntity?.created ? <TextFormat type="date" value={schedulingHistoryEntity?.created} format={APP_DATE_FORMAT} /> : null}
              </CustomHeadTableCell>
              <CustomHeadTableCell>{statusChip(schedulingEntity)}</CustomHeadTableCell>
              <CustomHeadTableCell>
                {schedulingEntity?.startTime ? <TextFormat type="date" value={schedulingEntity.startTime} format={APP_DATE_FORMAT} /> : null}
              </CustomHeadTableCell>
              <CustomHeadTableCell>
                {schedulingHistoryEntity?.scheduling?.endTime ? <TextFormat type="date" value={schedulingEntity.endTime} format={APP_DATE_FORMAT} /> : null}
              </CustomHeadTableCell>
              <CustomHeadTableCell>
                {schedulingEntity.truckImplement?.licensePlate}
                <IconButton color="secondary" component={Link} to={`dashboards/truck-implement/${schedulingEntity?.truckImplement?.id}`}>
                  <OpenInNewRounded fontSize="small" />
                </IconButton>
              </CustomHeadTableCell>
              <CustomHeadTableCell>{schedulingEntity.truckImplement?.description}</CustomHeadTableCell>
              <CustomHeadTableCell>
                {schedulingEntity?.user?.firstName} {schedulingEntity?.user?.lastName}
                <IconButton color="secondary" component={Link} to={`admin/user-management?emailSearch=${encodeURIComponent(schedulingEntity?.user?.email)}`}>
                  <OpenInNewRounded fontSize="small" />
                </IconButton>
              </CustomHeadTableCell>
              <CustomHeadTableCell>{schedulingEntity?.id}</CustomHeadTableCell>
              <CustomHeadTableCell>{schedulingEntity?.description}</CustomHeadTableCell>
            </TableRow>
            <TableRow
              sx={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                borderTop: '4px solid',
                borderBottom: '4px solid',
                borderColor: 'primary.main',
              }}
            ></TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const CustomHeadTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));
